import { Util } from '@grandvisionhq/forms'

export const isPostalCode =
  (country: string) =>
  (value: string): boolean =>
    Util.validations.isValidPostalCodeForCountry(country, value)

const REGEX = {
  ORDER_NUMBER: /^(OR(88|99)-)?([A-Za-z0-9]{8,10})$/,
}
export const isOrderNumber: Util.validations.Validator = (value: string) =>
  REGEX.ORDER_NUMBER.test(value)

export const getTextLength = (text: string): number => {
  const specialCharMap: Record<string, number> = {
    ä: 2,
    ö: 2,
    ü: 2,
    Ä: 2,
    Ö: 2,
    Ü: 2,
    ß: 2,
  }

  let length = 0

  for (const char of text) {
    length += specialCharMap[char] ?? 1
  }

  return length
}

const checkoutFieldsLengths: Record<string, number> & { default: number } = {
  fullName: 32,
  address_line_1: 32,
  default: 32,
  street: 32,
}

export const hasValidTextLength = (value: string, field: string): boolean => {
  const maxLength = checkoutFieldsLengths[field] ?? checkoutFieldsLengths.default
  return getTextLength(value) <= maxLength
}

export const isValidFullName = (input: string): boolean => {
  return Util.validations.isText(input) && hasValidTextLength(input, 'fullName')
}

export const isValidStreetName = (input: string): boolean => {
  return Util.validations.isStreetNameWithHouseNumber(input) && hasValidTextLength(input, 'street')
}

export const isValidStreetInfo = (input: string): boolean => {
  return Util.validations.isAddressLine(input) && hasValidTextLength(input, 'street')
}
